import BaseComponent from "../../BaseComponent";
import * as React from "react";
import FilterSearchBox from "../../FilterSearchBox";
import { List, ListItem } from "material-ui/List";
import { repository } from "clientInstance";
import Popover from "components/Popover/Popover";
import { ScriptingLanguage } from "components/scriptingLanguage";
import styles = require("./style.less");
import IconButton from "components/IconButton/IconButton";
const insertVariableIcon = require("./insert-variable.svg");

interface InsertVariableButtonProps {
    projectId?: string;
    projectEnvironmentsFilter?: string;
    localNames?: string[];
    syntax?: ScriptingLanguage;
    onSelected(value: string): void;
}

interface InsertVariableButtonState {
    allNames: string[];
    filteredNames: string[];
    functions: string[];
    filter: string;
    isInsertPopupOpen: boolean;
}

export default class InsertVariableButton extends BaseComponent<InsertVariableButtonProps, InsertVariableButtonState> {
    showInsertPopupButton: HTMLElement;

    constructor(props: InsertVariableButtonProps) {
        super(props);
        this.state = {
            allNames: null,
            filteredNames: null,
            functions: null,
            isInsertPopupOpen: false,
            filter: ""
        };
    }

    async componentDidMount() {
        const values = await repository.Variables.names(this.props.projectId, this.props.projectEnvironmentsFilter);
        const names = this.props.localNames ? [...this.props.localNames] : [];
        for (const value of values) {
            names.push(value);
        }

        if (this.props.syntax === ScriptingLanguage.PowerShell) {
            this.setState({
                functions: [
                    "New-OctopusArtifact",
                    "Set-OctopusVariable"
                ]
            });
        }
        this.setState({
            allNames: names,
            filteredNames: names
        });
    }

    showInsertPopup = (event: any) => {
        event.preventDefault();

        this.setState({
            isInsertPopupOpen: true
        });
    }

    hideInsertPopup = () => {
        this.setState({
            isInsertPopupOpen: false
        });
    }

    handleSelected = (value: string, delimit: boolean) => {
        const delimited = delimit ? this.delimit(value) : value;
        this.props.onSelected(delimited);
        this.hideInsertPopup();
    }

    render() {
//TODO Insert variable icon to be added
        return <div ref={this.setRef}>
                <IconButton toolTipContent="Insert a variable"
                            onClick={this.showInsertPopup}
                            icon={insertVariableIcon} />
                <Popover
                    open={this.state.isInsertPopupOpen}
                    anchorEl={this.showInsertPopupButton}
                    onRequestClose={this.hideInsertPopup}
                    anchorOrigin={{ horizontal: "middle", vertical: "bottom" }}
                    targetOrigin={{ horizontal: "middle", vertical: "top" }}>
                    <div className={styles.container} onKeyDown={this.onKeyDown}>
                        <div className={styles.filter}>
                            <FilterSearchBox autoFocus={true} value={this.state.filter} hintText="Find..." onChange={this.handleFilterChanged} />
                        </div>
                        {this.state.isInsertPopupOpen && <List className={styles.menuContainer}>
                            {this.menu()}
                            {this.functionmenu()}
                        </List>}
                    </div>
                </Popover>
            </div>;
    }

    private menu = () => (this.state.filteredNames || []).map((n, index) => {
        return <ListItem key={"item-" + index} primaryText={n} onClick={() => this.handleSelected(n, true)} />;
    })

    private functionmenu = () => (this.state.functions || []).map((n, index) => {
        return <ListItem key={"item-" + index} primaryText={n} onClick={() => this.handleSelected(n, false)} />;
    })

    private onKeyDown = (event: any) => {
        if (event.keyCode === 27 /*esc*/) {
            this.setState({ isInsertPopupOpen: false });
        }
    }

    private setRef = (el: any) => {
        this.showInsertPopupButton = el;
    }

    private handleFilterChanged = (val: string) => {
        const filteredNames = this.state.allNames.filter((item) => {
            return item.toLowerCase().search(
                val.toLowerCase()) !== -1;
        });
        this.setState({
            filteredNames,
            filter: val
        });
    }

    private delimit = (varname: string) => {
        const syntax = this.props.syntax;
        if (!syntax) {
            return `#{${varname}}`;
        }

        // Some escaping is probably required here.
        if (syntax === ScriptingLanguage.PowerShell) {
            if (varname.match(/^[A-z0-9]+$/)) {
                return "$" + varname;
            } else {
                return `$OctopusParameters["${varname}"]`;
            }
        }

        if (syntax === ScriptingLanguage.CSharp) {
            return `Octopus.Parameters["${varname}"]`;
        }

        if (syntax === ScriptingLanguage.Bash) {
            return `get_octopusvariable "${varname}"`;
        }

        if (syntax === ScriptingLanguage.FSharp) {
            return `Octopus.findVariable "${varname}"`;
        }

        return varname;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/InsertVariableButton/InsertVariableButton.tsx